import React, {useCallback, useEffect, useState} from 'react';
import {Checkbox, FormControlLabel, Tooltip, Typography} from '@mui/material';
import useIsMounted from "../../../../../../../hooks/use-is-mounted";
import {ReactComponent as MoreInfoIcon} from "../../../../../../../../assets/images/outlined-info-icon.svg";
import Api from "../../../../../../../../core/services/api/api";
import Grid from "@mui/material/Unstable_Grid2";

const TargetProcessTab = ({processes, setProcesses, submitting}) => {
    const [loading, setLoading] = useState(true);
    const [targetProcesses, setTargetProcesses] = useState([]);
    const isMounted = useIsMounted();

    /**
     * Fetches the target processes from the API
     * @type {(function(): Promise<void>)|*}
     */
    const getTargetProcesses = useCallback(async () => {
        setLoading(true);
        const response = await Api.listNcrProcesses();
        if (!isMounted())
            return;
        setLoading(false);
        if (response?.resultFlag) {
            setTargetProcesses(response.data ?? [])
        }
    }, [isMounted]);

    /**
     * As soon as the component mounts:
     * - fetches the target processes
     */
    useEffect(() => {
        void getTargetProcesses();
    }, [getTargetProcesses]);

    /**
     * Handles the change in the chosen processes for making the report
     * @param event
     */
    const handleChange = useCallback((event) => {
        setProcesses(prev => {
            const process = targetProcesses.find(item => item.id === parseInt(event.target.name));
            if (event.target.checked) {
                // Check if the item is already in the array to avoid duplicates
                if (!prev.some(item => item.id === process.id)) {
                    return [...prev, process];
                }
                return prev;
            } else {
                return prev.filter((item) => item.id !== parseInt(event.target.name));
            }
        });
    }, [setProcesses, targetProcesses]);

    return (
        <Grid container spacing={2} margin={0}>
            {
                loading &&
                Array.from({length: 10}, (_, i) => (
                    <Grid key={`loading-${i}`} xs={12} md={6}>
                        <div className={'loading small w-100'}>
                            <div/>
                        </div>
                    </Grid>
                ))
            }
            {
                !loading &&
                targetProcesses.map((process) => (
                    <Grid key={process?.id} xs={12} md={6}>
                        <FormControlLabel
                            sx={{margin: 0}}
                            label={
                                <Typography variant={'body2'} fontWeight={600}>
                                    {process.title}
                                    <Tooltip title={process.description}>
                                        <MoreInfoIcon className={'ml-2'}/>
                                    </Tooltip>
                                </Typography>
                            }
                            disabled={submitting}
                            control={
                                <Checkbox
                                    disabled={submitting}
                                    checked={!!processes.find(item => item.id === process.id)}
                                    onChange={handleChange}
                                />
                            }
                        />
                    </Grid>
                ))
            }
        </Grid>
    );
};

export default TargetProcessTab;
